import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/layouts/default.vue").then(m => m.default || m))
}